import { ELEMENT_HR, ELEMENT_IMAGE, } from '@udecode/plate';
const selectOnBackspacePlugin = {
    options: {
        query: {
            allow: [ELEMENT_IMAGE, ELEMENT_HR],
        },
    },
};
export default selectOnBackspacePlugin;
//# sourceMappingURL=selectOnBackspacePlugin.js.map